import '@babel/polyfill/dist/polyfill';
import Console from './console';

window.Console = Console;
